import React, { useState, useEffect } from 'react';
import { Upload, message, Modal } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';

type Iprops = {
  value?: any;
  action: string;
  size?: number;
  name?: string;
  accept?: string;
  fileType?: string;
  onChange?: any;
  maxNum?: any;
  multiple?: any;
  isUploading?: any;
  setIsUploading?: any;
}


const SPUpload: React.FC<Iprops> = (props) => {
  const { value, action, size = 2, accept, name = 'file', fileType,  onChange, maxNum = 1, multiple, setIsUploading } = props;
  const [loading, setLoading] = useState(false);
  const [myFileList, setMyFileList] = useState<any[]>([]);
  const [previewUrl, setPreviewUrl] = useState<string>('');
  const [previewOpen, setPreviewOpen] = useState<boolean>(false);

  const initFileList = (val: any) => {
    let list: any = [];
    const url = typeof val === 'string' ? val : val?.file_url;

    if (val) list.push({ uid: url, name: url, url, status: 'done', response: { data: val } });

    return list;
  };

  useEffect(() => {
    setIsUploading?.(loading)
  }, [loading]);


  const beforeUpload = (file: any) => {
    if (loading) {
      message.error(`视频上传中...`);
      return Upload.LIST_IGNORE;
    }
    const isLt = file.size / 1024 / 1024 < size;
    if (!isLt) {
      message.error(`文件大小不得超过 ${size} M`);
      return Upload.LIST_IGNORE;
    }
    setLoading(true);
  };

  const handleChange = (info: any) => {
    setMyFileList(info.fileList)
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }

    if (info.file.status === 'done') {
      const data = info?.file?.response?.data || {};
      const fileList = (info.fileList || []).filter((item: any) => item?.response?.data).map((item: any) => {
        const newItem = {
          ...item,
          url: data.file_url,
          videoUrl: data.file_url
        }
        return newItem;
      })
      setMyFileList(fileList);
      setLoading(false);
      onChange && onChange(multiple ? fileList.map((item: any) => item?.response?.data) : data);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} 上传失败`);
      setLoading(false);
      // 你可以在这里根据需求处理失败逻辑，例如移除失败的文件
      const fileList = (info.fileList || []).filter((item: any) => item.status !== 'error');
      setMyFileList(fileList);
      onChange && onChange(multiple ? fileList.map((item: any) => item?.response?.data) : null); // 或者根据需要设置空值
    }
  };

  const handlePreview = async (file: any) => {
    setPreviewUrl((fileType === 'video' ? file.videoUrl : file.url) || (file.preview as string));
    setPreviewOpen(true);
  };

  const handleCancel = () => setPreviewOpen(false);

  useEffect(() => {
    setMyFileList(initFileList(value));
  }, []);

  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>上传</div>
    </button>
  );

  return (
    <>
      <Upload
        name={name}
        listType="picture-card"
        action={action}
        accept={accept}
        maxCount={maxNum}
        multiple={multiple}
        fileList={myFileList}
        showUploadList={true}
        onPreview={handlePreview}
        beforeUpload={beforeUpload}
        onChange={handleChange}
      >
        {myFileList?.length === maxNum ? null : uploadButton}
      </Upload>
      {
        previewOpen && <Modal open={previewOpen} title="预览" footer={null} onCancel={handleCancel} destroyOnClose>
          <div style={{ textAlign: 'center' }}>
            {fileType !== 'video'
              ? <img alt="example" style={{ maxWidth: '60vh', maxHeight: '60vh' }} src={previewUrl} />
              : <video style={{ maxHeight: '60vh' }} width="100%" controls>
                <source src={previewUrl} type="video/mp4" />
                您的浏览器不支持视频标签。
              </video>}
          </div>
        </Modal>
      }
    </>
  )
}

export default SPUpload;
